export default "__VITE_ASSET__Bly0f$Bf__"